<template>
  <div ref="support">
    <div @click="toggleSupport" class="support-icon">?</div>
    <div
      v-show="supportOpen"
      style="
        position: absolute;
        bottom: 50px;
        pointer-events: auto;
        right: 16px;
        z-index: 9999;
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          position: relative;
          flex-direction: column;
          transform-origin: 100% bottom;
          left: 0px;
          bottom: 12px;
          opacity: 1;
        "
      >
        <div class="support-container">
          <div
            style="
              display: flex;
              flex-direction: column;
              min-width: 208px;
              max-width: calc(100vw - 24px);
              height: 100%;
              max-height: 70vh;
            "
          >
            <div
              class="cofocus-scroller vertical"
              style="
                flex-grow: 1;
                min-height: 0px;
                transform: translateZ(0px);
                z-index: 1;
                overflow: hidden auto;
                margin-right: 0px;
                margin-bottom: 0px;
              "
            >
              <div>
                <div style="padding-top: 6px; padding-bottom: 6px">
                  <!-- <div
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin-left: 14px;
                        "
                      >
                        <svg
                          viewBox="0 0 16 16"
                          class="helpButtonGuide"
                          style="
                            width: 16px;
                            height: 16px;
                            display: block;
                            fill: rgb(55, 53, 47);
                            flex-shrink: 0;
                            backface-visibility: hidden;
                            color: rgb(55, 53, 47);
                          "
                        >
                          <path
                            d="M8 2.77344C7.39844 2.0625 6.05859 1.42676 4.48633 1.42676C2.3877 1.42676 0.692383 2.51367 0.241211 3.5459V13.8066C0.241211 14.4766 0.678711 14.7363 1.16406 14.7363C1.52637 14.7363 1.73145 14.627 1.96387 14.4561C2.42871 14.0801 3.1875 13.6426 4.48633 13.6426C5.79199 13.6426 6.68066 14.0801 7.07715 14.415C7.2959 14.5791 7.54883 14.7363 8 14.7363C8.45117 14.7363 8.69727 14.5654 8.92285 14.415C9.34668 14.1006 10.208 13.6426 11.5137 13.6426C12.8125 13.6426 13.585 14.0869 14.0361 14.4561C14.2686 14.627 14.4736 14.7363 14.8359 14.7363C15.3213 14.7363 15.7588 14.4766 15.7588 13.8066V3.5459C15.3076 2.51367 13.6191 1.42676 11.5137 1.42676C9.94141 1.42676 8.6084 2.0625 8 2.77344ZM1.72461 4.01758C1.90918 3.56641 2.9209 2.80078 4.48633 2.80078C6.05176 2.80078 7.09766 3.57324 7.26172 4.01758V13.0342C6.55762 12.5283 5.55273 12.2549 4.48633 12.2549C3.41309 12.2549 2.41504 12.5283 1.72461 13.0547V4.01758ZM14.2754 4.01758V13.0547C13.585 12.5283 12.5869 12.2549 11.5137 12.2549C10.4473 12.2549 9.44238 12.5283 8.73828 13.0342V4.01758C8.90234 3.57324 9.94824 2.80078 11.5137 2.80078C13.0791 2.80078 14.0908 3.56641 14.2754 4.01758Z"
                          ></path>
                        </svg>
                      </div>
                      <div
                        style="
                          margin-left: 8px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div style="display: flex">
                          Help &amp; support guide
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div
                    @click="openVideo"
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin-left: 14px;
                        "
                      >
                        <svg
                          viewBox="0 0 24 24"
                          class="helpButtonSales"
                          style="
                            width: 17px;
                            height: 17px;
                            display: block;
                            fill: rgb(55, 53, 47);
                            flex-shrink: 0;
                            backface-visibility: hidden;
                            color: rgb(55, 53, 47);
                          "
                        >
                          <path
                            d="m6 5c0-.77179083.83721439-1.25266194 1.50387103-.8637789l11.99999997 7c.6615053.3858781.6615053 1.3416797 0 1.7275578l-11.99999997 7c-.66665664.388883-1.50387103-.0919881-1.50387103-.8637789zm2 1.741037v10.517926l9.0153651-5.258963z"
                            fill-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <div
                        style="
                          margin-left: 8px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div style="display: flex">Watch how-to video</div>
                      </div>
                    </div>
                  </div>
                  <a
                    href="https://www.cofocus.one/information/contact"
                    target="_blank"
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin-left: 14px;
                        "
                      >
                        <svg
                          viewBox="0 0 16 16"
                          class="helpButtonSales"
                          style="
                            width: 16px;
                            height: 16px;
                            display: block;
                            fill: rgb(55, 53, 47);
                            flex-shrink: 0;
                            backface-visibility: hidden;
                            color: rgb(55, 53, 47);
                          "
                        >
                          <path
                            d="M8 8.19c2.009 0 3.636-1.777 3.636-3.952C11.636 2.097 10.009.395 8 .395c-2 0-3.644 1.727-3.636 3.86C4.373 6.42 5.991 8.189 8 8.189zm0-1.453c-1.146 0-2.117-1.088-2.117-2.482C5.875 2.894 6.846 1.848 8 1.848c1.162 0 2.117 1.029 2.117 2.39 0 1.395-.963 2.499-2.117 2.499zm-5.18 9.172h10.351c1.436 0 2.125-.456 2.125-1.436 0-2.283-2.847-5.32-7.296-5.32-4.45 0-7.305 3.037-7.305 5.32 0 .98.69 1.436 2.125 1.436zm-.257-1.453c-.2 0-.274-.066-.274-.215 0-1.27 2.05-3.636 5.711-3.636 3.652 0 5.703 2.366 5.703 3.636 0 .15-.075.216-.274.216H2.563z"
                          ></path>
                        </svg>
                      </div>
                      <div
                        style="
                          margin-left: 8px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div style="display: flex">Contact us</div>
                      </div>
                    </div>
                  </a>
                  <!-- <div
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin-left: 14px;
                        "
                      >
                        <svg
                          viewBox="0 0 24 24"
                          class="feedback"
                          style="
                            width: 16px;
                            height: 16px;
                            display: block;
                            fill: rgb(55, 53, 47);
                            flex-shrink: 0;
                            backface-visibility: hidden;
                            color: rgb(55, 53, 47);
                          "
                        >
                          <path
                            d="M19,14h2a1,1,0,0,0,0-2H19V11a5.15,5.15,0,0,0-.21-1.36A5,5,0,0,0,22,5a1,1,0,0,0-2,0,3,3,0,0,1-2.14,2.87A5,5,0,0,0,16,6.4,2.58,2.58,0,0,0,16,6,4,4,0,0,0,8,6a2.58,2.58,0,0,0,0,.4,5,5,0,0,0-1.9,1.47A3,3,0,0,1,4,5,1,1,0,0,0,2,5,5,5,0,0,0,5.21,9.64,5.15,5.15,0,0,0,5,11v1H3a1,1,0,0,0,0,2H5v1a7,7,0,0,0,.14,1.38A5,5,0,0,0,2,21a1,1,0,0,0,2,0,3,3,0,0,1,1.81-2.74,7,7,0,0,0,12.38,0A3,3,0,0,1,20,21a1,1,0,0,0,2,0,5,5,0,0,0-3.14-4.62A7,7,0,0,0,19,15Zm-8,5.9A5,5,0,0,1,7,15V11a3,3,0,0,1,3-3h1ZM10,6a2,2,0,0,1,4,0Zm7,9a5,5,0,0,1-4,4.9V8h1a3,3,0,0,1,3,3Z"
                          />
                        </svg>
                      </div>
                      <div
                        style="
                          margin-left: 8px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div style="display: flex">Report a bug</div>
                      </div>
                    </div>
                  </div> -->
                  <a
                    href="https://forms.gle/3zBJtFt7Zb2hadLD8"
                    target="_blank"
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          margin-left: 14px;
                        "
                      >
                        <svg
                          viewBox="0 0 16 16"
                          class="feedback"
                          style="
                            width: 16px;
                            height: 16px;
                            display: block;
                            fill: rgb(55, 53, 47);
                            flex-shrink: 0;
                            backface-visibility: hidden;
                            color: rgb(55, 53, 47);
                          "
                        >
                          <path
                            d="M1.082 5.867c0 2.92 2.454 5.804 6.269 8.265.212.137.471.273.649.273.178 0 .438-.136.65-.273 3.82-2.461 6.268-5.346 6.268-8.265 0-2.522-1.743-4.272-3.978-4.272-1.306 0-2.325.594-2.94 1.497-.602-.896-1.627-1.497-2.933-1.497-2.242 0-3.985 1.75-3.985 4.272zM2.49 5.86c0-1.722 1.135-2.891 2.66-2.891 1.23 0 1.92.745 2.351 1.394.191.28.321.37.499.37.185 0 .3-.096.499-.37.465-.635 1.128-1.394 2.352-1.394 1.53 0 2.666 1.169 2.666 2.891 0 2.407-2.502 5.073-5.387 6.987-.062.04-.103.068-.13.068-.027 0-.068-.027-.123-.068C4.992 10.933 2.49 8.267 2.49 5.86z"
                          ></path>
                        </svg>
                      </div>
                      <div
                        style="
                          margin-left: 8px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div style="display: flex">Give feedback</div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  style="
                    padding-top: 6px;
                    padding-bottom: 6px;
                    box-shadow: rgba(55, 53, 47, 0.09) 0px -1px 0px;
                    margin-top: 1px;
                  "
                >
                  <div
                    @click="toggleModal('miniGuidelines')"
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          margin-left: 14px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          "
                        >
                          Session guidelines
                        </div>
                      </div>
                    </div>
                  </div>
                  <a
                    href="/help/community-guidelines"
                    target="_blank"
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          margin-left: 14px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          "
                        >
                          Community Guidelines
                        </div>
                      </div>
                    </div>
                  </a>
                  <a
                    href="/help/safety-on-cofocus"
                    target="_blank"
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                      "
                    >
                      <div
                        style="
                          margin-left: 14px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          "
                        >
                          Safety on Cofocus
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  style="
                    padding-top: 6px;
                    padding-bottom: 6px;
                    box-shadow: rgba(55, 53, 47, 0.09) 0px -1px 0px;
                    margin-top: 1px;
                  "
                >
                  <div
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <a
                      href="https://www.cofocus.one/dashboard/announcements"
                      target="_blank"
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                        padding-top: 4px;
                        padding-bottom: 4px;
                      "
                    >
                      <div
                        style="
                          margin-left: 14px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: rgba(55, 53, 47, 0.6);
                            margin-top: 2px;
                            font-size: 12px;
                          "
                        >
                          📢 Announcements
                        </div>
                      </div>
                    </a>
                  </div>
                  <a
                    href="https://www.cofocus.one/information/terms"
                    target="_blank"
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      target="_blank"
                      class="support-link"
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                        padding-top: 4px;
                        padding-bottom: 4px;
                      "
                    >
                      <div
                        style="
                          margin-left: 14px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: rgba(55, 53, 47, 0.6);
                            margin-top: 2px;
                            font-size: 12px;
                          "
                        >
                          Terms &amp; privacy
                        </div>
                      </div>
                    </div>
                  </a>
                  <!-- <div
                    class="cofocus-focusable"
                    role="button"
                    tabindex="0"
                    style="
                      user-select: none;
                      transition: background 20ms ease-in 0s;
                      cursor: pointer;
                      width: 100%;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        line-height: 120%;
                        width: 100%;
                        user-select: none;
                        min-height: 28px;
                        font-size: 14px;
                        padding-top: 4px;
                        padding-bottom: 4px;
                      "
                    >
                      <div
                        style="
                          margin-left: 14px;
                          margin-right: 14px;
                          min-width: 0px;
                          flex: 1 1 auto;
                        "
                      >
                        <div
                          style="
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: rgba(55, 53, 47, 0.6);
                            margin-top: 2px;
                            font-size: 12px;
                          "
                        >
                          Status
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div
                  style="
                    padding-top: 6px;
                    padding-bottom: 6px;
                    box-shadow: rgba(55, 53, 47, 0.09) 0px -1px 0px;
                    margin-top: 1px;
                  "
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      line-height: 120%;
                      width: 100%;
                      user-select: none;
                      min-height: 28px;
                      font-size: 14px;
                      padding-top: 4px;
                      padding-bottom: 4px;
                    "
                  >
                    <div
                      style="
                        margin-left: 14px;
                        margin-right: 14px;
                        min-width: 0px;
                        flex: 1 1 auto;
                      "
                    >
                      <div
                        style="
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          color: rgba(55, 53, 47, 0.6);
                          margin-top: 2px;
                          font-size: 12px;
                        "
                      >
                        <div style="color: rgba(55, 53, 47, 0.4)">
                          © 2024 Cofocus<br /><span
                            style="display: block; margin-top: 5px"
                            >Made with ❤️</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <footer style="flex-shrink: 0"></footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SupportIcon",

  data() {
    return {
      supportOpen: false,
    };
  },
  computed: {
    ...mapState({
      helpCenter: (state) => state.modals.helpCenter,
    }),
  },
  mounted() {
    document.addEventListener("click", this.closeSupport);
  },
  beforeDestroy() {
    // console.log("@mixin closecomponent destroying!");
    document.removeEventListener("click", this.closeSupport);
  },
  methods: {
    toggleSupport() {
      this.supportOpen = !this.supportOpen;
    },
    closeSupport(e) {
      // console.log("@mixin closecomponent element: ", this.$el);
      if (!this.$refs.support.contains(e.target)) {
        this.supportOpen = false;
      }
    },
    toggleModal(modal) {
      this.$store.dispatch("modals/setModalState", {
        modal,
        newState: true,
      });
      this.toggleSupport();
    },
    openVideo() {
      this.supportOpen = false;
      this.$store.dispatch("onboarding/setWelcomeVideo", true);
      this.$store.dispatch("onboarding/setWelcomeStarted", true);
    },
  },
};
</script>

<style scoped>
.support-icon {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  transition: opacity 700ms ease 0s, color 700ms ease 0s,
    transform 200ms ease 0s;
  cursor: pointer;
  opacity: 1;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255 255 255 / 73%);
  bottom: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  font-size: 20px;
  box-shadow: rgb(15 15 15 / 10%) 0px 0px 0px 1px,
    rgb(15 15 15 / 10%) 0px 2px 4px;
  z-index: 101;
  transform: translateX(0px) translateZ(0px);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
}
.support-icon:hover {
  background-color: rgb(225 225 225 / 73%);
}
.support-container {
  background: white;
  position: relative;
  max-width: calc(100vw - 24px);
  /* border: 1
px
 solid rgb(239, 239, 239); */
  overflow: hidden;
  background-color: rgb(255 255 255 / 73%);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  /* box-shadow: 0px -2px 4px 0 #d4d4d457, 0px 1px 4px 0 #d4d4d457; */
  box-shadow: rgb(15 15 15 / 5%) 0px 0px 0px 1px,
    rgb(15 15 15 / 10%) 0px 3px 6px, rgb(15 15 15 / 20%) 0px 9px 24px;
  border-radius: 12px;
}
.support-link {
  display: block;
}
.support-link:hover {
  background-color: #e7e7e7;
}
</style>